import React from 'react';
import Avatar from '../common/Avatar';
import Username from '../common/Username';
import Moment from 'react-moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Comments from '../common/Comments';

const QuotesDetail = (props) => (
    <div>
        <h1>{props.quote.title}</h1>
        <div className="panel-adt">
            <blockquote style={{marginBottom:0}}>
                <p style={{whiteSpace:'pre-wrap'}}>{props.quote.body}</p>
                <small>
                    { props.quote.involved.length > 0 ? props.quote.involved.map((member) => (
                        <span key={`${member}-quotedmember`}>
                            <Username user={props.users[member]}
                                  rank={props.ranks[props.users[member].rank]} placement="left"/>
                            <span> </span>
                        </span>
                        )) : null
                    }
                </small>
            </blockquote>
        </div>
        <div className="panel-adt clearfix">
            <div className="comment-avatar pull-left">
                <Avatar image={props.users[props.quote.poster].avatar} rank={props.ranks[props.users[props.quote.poster].rank]} width="32" height="32" />
            </div>

            <div>
                <span>Submitted by </span>
                <Username user={props.users[props.quote.poster]} rank={props.ranks[props.users[props.quote.poster].rank]} placement="left" />
                <span> </span>
                <span className="timestamp">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="activity-feed-post-date"><Moment format="ddd MMM D YYYY">{props.quote.created}</Moment></Tooltip>}>
                        <Moment fromNow>{props.quote.created}</Moment>
                    </OverlayTrigger>
                </span>
            </div>
        </div>
        <Comments minSecurity="Public" item={`/quotes/${props.quote.slug}`} />
    </div>

);

export default QuotesDetail;


// WEBPACK FOOTER //
// ./src/Media/QuotesDetail.js